const fileMangerExplorerStyle = theme => ({
    root: {
        color: theme.palette.text.secondary,

        '&:hover > $content': {
            backgroundColor: theme.palette.action.hover,
        },
        '&:focus > $content, &$selected > $content': {
            backgroundColor: `var(--tree-view-bg-color, ${theme.palette.grey[400]})`,
            color: 'var(--tree-view-color)',
        },
        '&:focus > $content $label, &:hover > $content $label, &$selected > $content $label': {
            backgroundColor: 'transparent',
        },
    },

    content: {
        color: theme.palette.text.secondary,
        borderTopRightRadius: theme.spacing(2),
        borderBottomRightRadius: theme.spacing(2),
        paddingRight: theme.spacing(1),
        fontWeight: theme.typography.fontWeightMedium,
        '$expanded > &': {
            fontWeight: theme.typography.fontWeightRegular,
        },
    },

    group: {
        marginLeft: "20px",
        '& $content': {
            paddingLeft: theme.spacing(0),
        },
    },

    expanded: {},
    
    selected: {},
    
    label: {
        fontWeight: 'inherit',
        color: 'inherit',
    },
    
    labelRoot: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0.5, 0),
    },
    
    labelIcon: {
        color: 'var(--folder-color)',
        marginRight: theme.spacing(1),

    },
    
    labelText: {
        fontWeight: 'inherit',
        flexGrow: 1,
    },
})


export default fileMangerExplorerStyle